import React from "react";

const Forward = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M18 22.722h-3.2c-2.625 0-5.2.72-7.447 2.086a14.457 14.457 0 00-5.302 5.664c-.034-.434-.051-.87-.051-1.305 0-8.899 7.163-16.111 16-16.111V5l16 12.889-16 12.889v-8.056z"
            fill={fill}
        />
    </svg>
);

export default Forward;
